enum ActionState {
  IN_PROGRESS = 'in progress',
  COMPLETED = 'completed',
  FAILED = 'failed',
  NO_STATE = 'no state'
}

export default ActionState;
